export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden bg-background-100"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-100/40 via-background-50 to-accent-100/30"></div>

      <div className="relative w-full px-4 md:px-6 py-24 md:py-28">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-fire-line text-sm"></i>
              <span>每日更新 · 海量高清资源</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              天狼影院 · 高清免费在线观影平台
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-heading font-semibold mb-5">
              即点即播不缓冲，流畅追剧看电影
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-7 max-w-xl mx-auto lg:mx-0">
              天狼影院汇聚最新电视剧、热门电影、综艺大全，提供高清免费在线观看服务。每日同步更新热播资源，覆盖国产剧、韩剧、美剧、日剧、动漫等多个频道，即点即播无需等待，流畅观影不卡顿，是您追剧看电影的首选平台。当前热播《星辰大海》《暗夜追光》《山海传说》等口碑佳作持续更新中。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-sm text-foreground-600">日更新 <strong className="text-foreground-900">200+</strong> 部</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                <span className="text-sm text-foreground-600">覆盖 <strong className="text-foreground-900">12</strong> 大频道</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-sm text-foreground-600">高清 <strong className="text-foreground-900">1080P</strong> 画质</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => handleScroll('#carousel')}
                className="px-8 py-3 bg-primary-500 text-white font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-play-circle-line mr-2"></i>
                立即观影
              </button>
              <button
                onClick={() => handleScroll('#features')}
                className="px-8 py-3 border-2 border-primary-200 text-primary-700 font-medium rounded-md hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-information-line mr-2"></i>
                了解平台
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20cinematic%20abstract%20composition%20with%20flowing%20film%20strips%2C%20warm%20golden%20and%20deep%20red%20gradients%2C%20soft%20glowing%20orbs%20representing%20screens%2C%20modern%20minimalist%20design%2C%20dark%20elegant%20background%20with%20subtle%20texture%2C%203D%20rendered%20cinema%20aesthetic%2C%20atmospheric%20lighting%2C%20no%20text&width=800&height=600&seq=hero-visual-2026&orientation=landscape"
                alt="天狼影院 - 高清在线观影平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/25 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}